/* R798: private Data Hub report of hero page answers and rarity. Loaded only by ff-data-hub.
   Reads datahub_hero_fill_stats (sql/R798B) with the hub's own key and rpc and paints #hp-report
   (snippets/ff-data-hub-hero-pages.liquid). Checks: harness/r798-browser.cjs. */
(function(){
  "use strict";
  var TIERS=[["common","Common"],["uncommon","Uncommon"],["rare","Rare"],["epic","Epic"],["legendary","Legendary"],["mythic","Mythic"]];
  var SECTIONS={id:"Who they are",dr:"What drives them",pe:"People and places",ho:"Hooks for the DM",rp:"At the table",bp:"Blueprint"};
  var BOXES=["hp-spread","hp-sections","hp-bp","hp-tiers","hp-latest","hp-risen","hp-days"];
  window.ffHeroDataHub=function(ctx){
    var el=ctx.el,n=ctx.n,chip=ctx.chip,rpc=ctx.rpc;
    var whenChartReady=ctx.whenChartReady,renderSeries=ctx.renderSeries,setEmpty=ctx.setEmpty,seriesCache=ctx.seriesCache;
    var seq=0;
    function esc(t){return String(t==null?"":t).replace(/[&<>"']/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]})}
    function num(x){return n(Number(x)||0)}
    /* a number keeps its word on the same line (a no-break space) */
    function plural(x,one,many){return num(x)+" "+((Number(x)||0)===1?one:many)}
    function share(part,whole){return whole>0?Math.round(1000*(Number(part)||0)/whole)/10:0}
    function tierName(t){for(var i=0;i<TIERS.length;i++)if(TIERS[i][0]===t)return TIERS[i][1];return "Common"}
    function ago(t){
      var ms=Date.now()-new Date(t).getTime();if(!isFinite(ms))return "";
      var s=Math.max(0,Math.round(ms/1000));if(s<60)return s+"s ago";
      var m=Math.round(s/60);if(m<60)return m+"m ago";
      var h=Math.round(m/60);if(h<24)return h+"h ago";
      return Math.round(h/24)+"d ago";
    }
    function clock(t){var d=new Date(t);return isNaN(d.getTime())?"just now":d.toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit"})}
    /* 2026-09-13 reads 9/13, the UTC day the report's rows use */
    function day(s){var p=String(s||"").split("-");return p.length===3?(+p[1])+"/"+(+p[2]):String(s||"")}
    /* the Hall's own rule: a hero shown in the main Hall has a public page; a hidden or pending one keeps the Hall link */
    function href(h){var r=encodeURIComponent(String(h.ref||""));return h.in_hall?"/pages/hero?h="+r:"/pages/hall-of-heroes?hero="+r}
    function empty(msg){return '<div class="fh-empty">'+esc(msg)+'</div>'}
    function fact(k,v){return '<div class="hp-fact"><div class="k">'+esc(k)+'</div><div class="v">'+v+'</div></div>'}
    function bar(label,pct,value,sub){
      var w=Math.max(0,Math.min(100,Number(pct)||0));
      return '<div class="hp-bar"><span class="hp-bl">'+esc(label)+'</span><span class="hp-bt" aria-hidden="true"><i style="width:'+w+'%"></i></span>'
        +'<span class="hp-bv">'+value+'</span>'+(sub?'<small class="hp-bs">'+sub+'</small>':'')+'</div>';
    }
    function item(h,line,at){
      return '<a class="hp-item" href="'+esc(href(h))+'" target="_blank" rel="noopener"><span class="hp-who"><b>'+esc(h.name||"Unnamed hero")+'</b><small>'
        +esc(line+(h.in_hall?"":" · not in the Hall yet"))+'</small></span><span class="lt">'+esc(ago(at))+'</span></a>';
    }
    function render(d,s){
      var h=d.heroes||{},a=d.answers||{},u=d.tier_ups||{},b=d.blueprints||{},lg=d.legendary||{},t=d.tiers||{};
      var filling=Number(h.filling)||0,series=d.series||[],spread=d.spread||[];
      var most=Math.max.apply(null,spread.map(function(y){return Number(y.heroes)||0}).concat([1]));
      el("hp-chips").innerHTML=
        chip("Heroes filling in",num(h.filling),"of "+num(h.total)+" heroes · "+num(h.active_7d)+" saved this week")+
        chip("New answers · 7d",num(a.new_7d),num(a.new_24h)+" in 24h · "+num(a.saved_7d)+" saved counting edits")+
        chip("Tier-ups · 7d",num(u.d7),num(u.d30)+" in 30d · "+num(u.ever)+" since hero pages opened")+
        chip("Blueprints complete",num(b.complete),num(b.started)+" started · "+num(b.from_quest)+" from a Quest");
      el("hp-spread").innerHTML=filling?'<div class="hp-bars hp-spread">'+spread.map(function(x){
        return bar(x.from+" to "+x.to+" points",100*(Number(x.heroes)||0)/most,num(x.heroes)+" · "+share(x.heroes,filling)+"%");
      }).join("")+'</div>':empty("No hero has answers or a blueprint yet.");
      el("hp-legendary").textContent=filling?(plural(lg.earned,"hero","heroes")+" reached Legendary by points and a full blueprint. "
        +plural(lg.needs_blueprint,"more has","more have")+" the points but not the full blueprint."):"";
      el("hp-sections").innerHTML=filling?'<div class="hp-bars">'+(d.sections||[]).map(function(x){
        var p=Math.max(0,Math.min(100,Number(x.avg_pct)||0));
        return bar(SECTIONS[x.key]||x.key,p,p+"%",num(x.full)+" full · "+num(x.started)+" started");
      }).join("")+'</div>':empty("No hero has answers or a blueprint yet.");
      el("hp-bp").innerHTML='<div class="hp-facts">'+fact("Started",num(b.started))+fact("Complete",num(b.complete))
        +fact("Completed · 30d",num(b.complete_30d))+fact("From a Quest",num(b.from_quest))+'</div>';
      el("hp-tiers").innerHTML='<div class="hp-facts hp-tiers">'+TIERS.map(function(x){return fact(x[1],num(t[x[0]]))}).join("")+'</div>';
      el("hp-latest").innerHTML=(d.latest||[]).length?(d.latest||[]).map(function(x){
        return item(x,tierName(x.tier)+" · "+plural(x.points,"point","points")+" · "+(Number(x.answers)>0?plural(x.answers,"answer","answers"):"no answers yet")+" · blueprint "+num(x.bp_filled)+" of 9",x.at);
      }).join(""):empty("No answers saved yet. This fills in as players answer questions on their heroes' pages.");
      el("hp-risen").innerHTML=(d.risen||[]).length?(d.risen||[]).map(function(x){
        return item(x,"Rose to "+tierName(x.rose_to)+" · "+plural(x.points,"point","points")+(x.tier!==x.rose_to?" · shows as "+tierName(x.tier):""),x.at);
      }).join(""):empty("No tier-ups yet. One shows here when a hero's answers raise its rarity.");
      el("hp-days").innerHTML=series.length?'<table class="fh-bg-table"><thead><tr><th>Day</th><th>New answers</th><th>Heroes filling in</th><th>Tier-ups</th><th>Blueprints completed</th></tr></thead><tbody>'
        +series.slice().reverse().map(function(x){
          return '<tr><td data-label="Day">'+esc(day(x.day))+'</td><td data-label="New answers">'+num(x.answers)+'</td><td data-label="Heroes filling in">'+num(x.heroes)
            +'</td><td data-label="Tier-ups">'+num(x.tier_ups)+'</td><td data-label="Blueprints completed">'+num(x.blueprints)+'</td></tr>';
        }).join("")+'</tbody></table>':empty("No days in this report.");
      el("hp-status").textContent="Updated "+clock(d.as_of)+". Dates use UTC. A name opens that hero's page.";
      whenChartReady(function(){
        if(s!==seq)return;
        renderSeries("hpLine",series.map(function(x){return String(x.day).slice(5)}),series.map(function(x){return Number(x.answers)||0}),
          series.map(function(x){return Number(x.heroes)||0}),"New answers","Heroes filling in","#3987e5","#d95926","No answers saved in the last 30 days.");
      });
    }
    function why(e){
      var body={};try{body=JSON.parse(e&&e.message||"{}")}catch(ignore){}
      if(body.code==="PGRST202"||body.code==="42883")return "The Hero pages report is not installed yet. Run R798A, R798B and R798C in Supabase.";
      if(e&&(e.status===401||e.status===403)||body.message==="bad key")return "Access was not accepted. Re-enter your Data Hub key and reload.";
      if(body.code==="57014")return "The report took too long and stopped. Use Refresh to retry.";
      return "Hero page data could not be loaded. Use Refresh to retry.";
    }
    function fail(e){
      el("hp-chips").innerHTML=empty(why(e));
      BOXES.forEach(function(id){el(id).innerHTML=empty("Report unavailable.")});
      el("hp-legendary").textContent="";el("hp-status").textContent="";
      setEmpty("hpLine","Report unavailable.");delete seriesCache.hpLine;
    }
    /* HUB-01: where each tier-up rose from, "Uncommon → Legendary". datahub_hero_rises only knows rises since HUB-01
       was installed, matched to this list by hero and moment, so older rows keep "Rose to". Before HUB-01 the call
       is missing and the list stays exactly as render() drew it. */
    function rises(k,s,d){
      var rows=d.risen||[];
      if(!rows.length)return;
      rpc("datahub_hero_rises",{p_key:k,p_limit:40}).then(function(list){
        if(s!==seq||!Array.isArray(list)||!list.length)return;
        var from={};
        list.forEach(function(x){if(x&&x.from)from[String(x.ref)+"|"+Date.parse(x.at)]=x.from});
        el("hp-risen").innerHTML=rows.map(function(x){
          var f=from[String(x.ref)+"|"+Date.parse(x.at)];
          return item(x,(f?tierName(f)+" → "+tierName(x.rose_to):"Rose to "+tierName(x.rose_to))+" · "+plural(x.points,"point","points")
            +(x.tier!==x.rose_to?" · shows as "+tierName(x.tier):""),x.at);
        }).join("");
      }).catch(function(){});
    }
    function load(k){
      var s=++seq,panel=el("hp-report");
      panel.setAttribute("aria-busy","true");el("hp-status").textContent="Updating hero pages…";
      rpc("datahub_hero_fill_stats",{p_key:k}).then(function(d){
        if(s!==seq)return;
        if(!d||d.version!==798)throw new Error("Unexpected report version");
        render(d,s);panel.setAttribute("aria-busy","false");
        rises(k,s,d);
      }).catch(function(e){
        if(s!==seq)return;
        fail(e);panel.setAttribute("aria-busy","false");
      });
    }
    return {load:load};
  };
  window.dispatchEvent(new Event("ff-hero-report-ready"));
})();
